// BoldLink.js
import React from 'react';
import { Link } from 'react-router-dom';
import './BoldLink.css';

const BoldLink = ({to, children}) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return <Link to={to} className='boldlink' onClick={handleClick}>{children}</Link>
}

export default BoldLink;
